import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { Heading } from 'components/Heading';
import { RichTextContent } from 'components/RichTextContent';
import { SkinLogo } from 'components/SkinLogo';
import { requireGameLoaded } from 'engine/api';
import { useStore } from 'engine/store';
import { type FC } from 'react';
import { MobileScreen } from 'components/MobileScreen';
import { Para } from 'components/Para';

export const Route = createFileRoute('/intro')({
	component: RouteComponent,
	beforeLoad: requireGameLoaded,
});

function RouteComponent() {
	const game = useStore((s) => s.game);

	return (
		<>
			{!game && <span>no game</span>}
			{game && <GameIntro title={game.title} subtitle={game.subtitle} desc={game.description} />}
		</>
	);
}

const GameIntro: FC<{ title: string; subtitle?: string; desc?: string }> = ({ title, subtitle, desc }) => {
	const navigate = useNavigate();
	const setPlayState = useStore((s) => s.setPlayState);
	const { game, eventStatus } = useStore((s) => s);

	return (
		<MobileScreen className="flex flex-col items-center">
			<SkinLogo />
			<div className="size-8"></div>
			<Heading mode="primary">{title}</Heading>
			{subtitle && <small>{subtitle}</small>}
			{desc && <RichTextContent className="mt-8 text-center" content={desc} />}
			<div className="mt-6 w-full">
				{eventStatus == 'open' && <Para className="mb-1 text-center italic">{__`Wait until the game starts`}.</Para>}
				<Button
					disabled={eventStatus == 'open'}
					onClick={() => {
						if (game?.type === 'double-dealer') {
							setPlayState('registering-members');

							navigate({
								to: '/register-members',
								viewTransition: { types: ['slide-left'] },
							});
						} else {
							setPlayState('playing');

							navigate({
								to: '/rounds',
								viewTransition: { types: ['slide-down'] },
							});
						}
					}}
					className="w-full"
				>
					{__`Start`}
				</Button>
			</div>
		</MobileScreen>
	);
};
